import React, { useState, useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getRequest, postRequest } from "../../../globalhelper/helper";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { hideLoader, showAlert, showLoader } from '../../../redux/Common/commonActions';
import { useDispatch } from 'react-redux';
import DownloadIcon from '@mui/icons-material/Download';

function Water_fall() {
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [fromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [toDate, setToDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [tableData, setTableData] = useState([]);
    let dispatch = useDispatch();
    useEffect(() => {
        getRequest(`api/edureka/getCompanyAssignedToUser`)
            .then(({ res }) => {
                setCompanies(
                    (res.data || []).sort((a, b) =>
                        (a.orgname || "").localeCompare(b.orgname || ""),
                    ),
                );
                if (res.data && res.data.length === 1) {
                    setSelectedCompany(res.data[0]);
                }
            })
            .catch((error) => console.log(error));
    }, []);

    const handleSubmit = async () => {
        try {
            dispatch(showLoader());
            let { res } = await postRequest('api/vr2/getWaterfallReport', {
                organizationid: selectedCompany.orgid,
                fromDate,
                toDate
            });

            let parsedData = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            if (parsedData && parsedData.length > 0) {
                setTableData(parsedData);
            } else {
                setTableData([]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const convertToCSV = (data) => {
        if (!data || !data.length) return '';
        const headers = Array.from(new Set(data.flatMap(Object.keys)));
        const headerRow = headers.join(',');
        const rows = data.map(row =>
            headers.map(header => JSON.stringify(row[header] ?? '')).join(',')
        );
        return [headerRow, ...rows].join('\n');
    };

    const downloadCSV = () => {
        const csvData = convertToCSV(tableData);
        const now = new Date().toISOString().replace(/[-:.TZ]/g, '');
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `WaterFall_${now}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div style={{ padding: '20px' }}>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant='h6'>Search</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                disablePortal
                                id="company-autocomplete-test2"
                                options={companies}
                                getOptionLabel={(option) => option?.orgname || ""}
                                isOptionEqualToValue={(option, value) => option?.orgid === value?.orgid}
                                value={selectedCompany}
                                onChange={(event, newValue) => setSelectedCompany(newValue)}
                                fullWidth
                                renderInput={(params) => <TextField {...params} label="Company" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="From Date"
                                    value={fromDate ? moment(fromDate) : null}
                                    views={['day', 'month', 'year']}
                                    onChange={(newValue) => setFromDate(newValue ? newValue.format('YYYY-MM-DD') : null)}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="To Date"
                                    value={toDate ? moment(toDate) : null}
                                    views={['day', 'month', 'year']}
                                    onChange={(newValue) => setToDate(newValue ? newValue.format('YYYY-MM-DD') : null)}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button variant="contained" color="primary" onClick={handleSubmit} sx={{ height: '56px' }} disabled={!selectedCompany || !fromDate || !toDate}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {tableData.length > 0 && (
                <>
                    <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
                        <Button variant="contained" color="success" onClick={downloadCSV} startIcon={<DownloadIcon />}>
                            Download CSV
                        </Button>
                    </Grid>
                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {Object.keys(tableData[0]).map((key, index) => {
                                        const isRightAligned = key === 'Revenue_Recognized' || key.startsWith('PER');
                                        return (
                                            <TableCell key={index} sx={{ textAlign: isRightAligned ? 'right' : 'left' }}><b>{key}</b></TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        {Object.entries(row).map(([key, val], valIndex) => {
                                            let displayVal = val;
                                            if (typeof val === 'number' && !Number.isInteger(val)) {
                                                displayVal = val.toFixed(2);
                                            } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                                                displayVal = parseFloat(val).toFixed(2);
                                            }
                                            const isRightAligned = key === 'Revenue_Recognized' || key.startsWith('PER');
                                            return (
                                                <TableCell key={valIndex} sx={{ textAlign: isRightAligned ? 'right' : 'left' }}>
                                                    {displayVal}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}
        </div>
    )
}

export default Water_fall;